module.exports = ".docs_filename {\n  width: calc(100% - 50px); }\n\n.sliders_filename {\n  width: calc(100% - 100px); }\n"